import React, { Component } from 'react'
import { Box, CustomizedErrorMessage } from '../../styles.style'
import { getIn } from 'formik'
import {
	PhoneInput
} from '../../../../components/form-components/inputs.component'

class Phone extends Component {
	constructor(props) {
		super(props)
		this.state = {
			phone: '',
			phoneError: 'Informe o Telefone'
		}
	}

	nextPage = () => {
		this.props.handleSetPhone(this.props.values.phone)
		this.props.nextStep()
	}

	setPhone = e => {
		const phone = this.props.values.phone;
		var errorMessage = ''
		if (!phone) {
			errorMessage = 'Informe o Telefone'
		} else
			if (phone.length < 10)
				errorMessage = 'Informe o telefone completo'

		this.setState({ phone: phone, phoneError: errorMessage })
	}

	render() {
		const {
			values,
			errors,
			touched,
			prevStep
		} = this.props
		const { phoneError } = this.state

		return (
			<Box>
				<div className="field">
					<header>
						<h5>Por último, precisamos do seu telefone</h5>
					</header>

					<div>
						<PhoneInput
							{...this.props}
							className={
								getIn(errors, 'phone') &&
									getIn(touched, 'phone')
									? 'field-error input-big'
									: 'input-big'
							}
							label=""
							id="phone"
							name="phone"
							placeholder="Telefone"
							onComplete={this.setPhone}
						/>
						{phoneError && (
							<CustomizedErrorMessage>
								{phoneError}
							</CustomizedErrorMessage>
						)}
					</div>
				</div>


				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => prevStep()}>
						Voltar
					</button>
					<button
						disabled={
							!values.phone ||
							this.state.phoneError ||
							values.phone.length == 0 ||
							(errors.phone && touched.phone)
						}
						className={
							errors.phone && touched.phone || this.state.phoneError
								? 'disabled button'
								: 'button'
						}
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default Phone
